class SellingPlanDropdown extends HTMLElement {
  connectedCallback() {
    const select = this.querySelector('.custom-selling-plan-dropdown');
    if (!select) return;

    if (select.dataset.listenerAttached === 'true') return;
    select.dataset.listenerAttached = 'true';

    select.addEventListener('change', async (e) => {
      e.stopImmediatePropagation();

      const sellingPlanId = select.value === 'null' ? null : select.value;
      const line = parseInt(select.dataset.line, 10);

       let quantity = parseInt(select.dataset.quantity, 10);
      
      console.log(quantity);
      
      if (typeof this.showLoader === 'function') this.showLoader();

      try {
        // Update cart with selling plan
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            line: line,
            quantity: quantity,
            selling_plan: sellingPlanId
          })
        });

        const cart = await res.json();
        console.log('Cart updated', cart);

        // Dispatch event for other scripts
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData: cart } }));

        // Re-render full cart drawer
        this.updateFullCartDrawer();

      } catch (err) {
        console.error('Error updating cart:', err);
        if (typeof this.showCartError === 'function') {
          this.showCartError('There was an error while updating your cart. Please try again.');
        }
      } finally {
        if (typeof this.hideLoader === 'function') this.hideLoader();
      }
    });
  }

  // Method to fetch and replace cart drawer
  updateFullCartDrawer() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const newCartDrawer = html.querySelector('#CartDrawer');
        const currentCartDrawer = document.querySelector('#CartDrawer');
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.replaceWith(newCartDrawer);
          window.initUpsellSwiper?.();
        }
      })
      .catch((err) => console.error('Failed to update #CartDrawer:', err));
  }

  // Optional loader/error methods (if your theme has them)
  showLoader() {
    if (typeof window.showLoader === 'function') window.showLoader();
  }

  hideLoader() {
    if (typeof window.hideLoader === 'function') window.hideLoader();
  }

  showCartError(message) {
    if (typeof window.showCartError === 'function') window.showCartError(message);
  }
}

customElements.define('selling-plan-dropdown', SellingPlanDropdown);
